/** Must match backend `SESSION_HINT_COOKIE`. Readable (not httpOnly) session flag. */
export const SESSION_HINT_COOKIE = 'ns_sess'

export function hasSessionHint(): boolean {
  if (!import.meta.client) return false
  return document.cookie.split(';').some(part => part.trim().startsWith(`${SESSION_HINT_COOKIE}=`))
}

export function clearSessionHint(): void {
  if (!import.meta.client) return
  const expires = 'Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT'
  for (const sameSite of ['Lax', 'None', 'Strict']) {
    document.cookie = `${SESSION_HINT_COOKIE}=; Path=/; ${expires}; SameSite=${sameSite}`
    document.cookie = `${SESSION_HINT_COOKIE}=; Path=/api; ${expires}; SameSite=${sameSite}`
  }
}
